import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import isObject from "../../../utils/isObject";
import { PulsatingButtonContainer, PulsatingButton, Text, TextPlaceholder } from "./PulseButtonAtm.styled";
function PulseButtonAtm(_ref) {
  var children = _ref.children,
    to = _ref.to,
    href = _ref.href,
    openInNewTab = _ref.openInNewTab,
    title = _ref.title,
    color = _ref.color,
    onClick = _ref.onClick;
  var buttonRef = useRef(null);
  var tl = useRef(null);
  useEffect(function () {
    var button = buttonRef.current;
    tl.current = gsap.timeline({
      repeat: -1,
      yoyo: true
    });
    tl.current.to(button, {
      duration: 1,
      scale: 1.2,
      ease: "power1.inOut"
    });
    return function () {
      if (tl.current) {
        tl.current.kill();
      }
    };
  }, []);
  var handleHover = function handleHover() {
    if (tl.current) {
      tl.current.progress(1, false);
      tl.current.pause();
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (tl.current) {
      tl.current.resume();
    }
  };
  var isCustomColor = isObject(color);
  return /*#__PURE__*/React.createElement(PulsatingButtonContainer, {
    title: title,
    to: to,
    href: href,
    openInNewTab: openInNewTab,
    onClick: onClick,
    onMouseEnter: handleHover,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React.createElement(PulsatingButton, {
    ref: buttonRef,
    $color: !isCustomColor ? color : undefined,
    $customColor: isCustomColor ? color.background : undefined
  }, /*#__PURE__*/React.createElement(TextPlaceholder, null, children)), /*#__PURE__*/React.createElement(Text, {
    $color: isCustomColor ? color.text : undefined,
    $onColor: !isCustomColor ? color : undefined
  }, children));
}
export default PulseButtonAtm;